import {defineType} from 'sanity'

export const tsdocSeeBlockType = defineType({
  type: 'object',
  name: 'tsdoc.seeBlock',
  title: 'See block',
  fields: [
    {
      type: 'array',
      name: 'content',
      title: 'Content',
      of: [
        {
          type: 'block',
        },
        {
          type: 'code',
          name: 'code',
          title: 'Code',
        },
      ],
    },
  ],
})
